

export default function CustomInput ({setText, placeholder = "", minHeight= 0}) {
    return (
        <input
               onChange={(e) => {setText(e.target.value)}} style={{display: "flex", flex: 1, backgroundColor: "white", borderRadius: 10, padding: 15,borderStyle: "solid", borderWidth: 1, borderColor: "black", margin: 10, minHeight: minHeight}} placeholder={placeholder}/>
    )
}